import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';

import { FloatingStackingService } from './floating-stacking.service';

@Directive({
  selector: '[shrdUicFloatingContainer]'
})
export class FloatingContainerDirective implements OnInit, OnDestroy {
  constructor(private readonly elRef: ElementRef, private readonly floatingStackingService: FloatingStackingService) {}

  ngOnInit(): void {
    this.floatingStackingService.setScrollContainer(this.elRef.nativeElement);
  }

  ngOnDestroy(): void {
    this.floatingStackingService.removeScrollContainer(this.elRef.nativeElement);
  }
}
